import { defineMessages } from 'react-intl';

export default defineMessages({
  social_networks: {
    id: 'Social networks',
    defaultMessage: 'Social networks',
  },
});
